import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { EntityQuery } from '@cime/breeze-client';
import { AbstractBreezeViewComponent } from '@common/classes/breeze-view';
import { VesselVisitStatusCodes } from '@common/classes/codes';
import { VesselVisitPermissions } from '@common/classes/permissions';
import { AppControlComponent } from '@common/components/app-control/app-control.component';
import { ViewMode } from '@common/models/view-mode';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { AddExistingInvoiceModalComponent } from '@vessel-visit/components/add-existing-invoice-modal/add-existing-invoice-modal.component';
import _ from 'lodash';
import * as i0 from "@angular/core";
import * as i1 from "@common/services/breeze-view.service";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "@progress/kendo-angular-layout";
import * as i6 from "../action-bar/action-bar.component";
import * as i7 from "../app-control/app-control.component";
import * as i8 from "../loader/loader.component";
import * as i9 from "../content-header/content-header.component";
import * as i10 from "../note-list/note-list.component";
import * as i11 from "../invoice-list/invoice-list.component";
import * as i12 from "../vessel-visit-event-list/vessel-visit-event-list.component";
import * as i13 from "../vessel-visit-service-list/vessel-visit-service-list.component";
import * as i14 from "@ngx-translate/core";
const _c0 = ["files"];
const _c1 = ["tabStrip"];
const _c2 = ["callActivitiesControl"];
function VesselVisitViewComponent_app_action_bar_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-action-bar", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("items", ctx_r0.actionBar);
  }
}
function VesselVisitViewComponent_ng_template_2_ng_template_66_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-vessel-visit-event-list", 32);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("editMode", ctx_r3.editMode && !ctx_r3.cardView)("model", ctx_r3.model);
  }
}
function VesselVisitViewComponent_ng_template_2_ng_template_69_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-vessel-visit-service-list", 32);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("editMode", ctx_r4.editMode && !ctx_r4.cardView)("model", ctx_r4.model);
  }
}
function VesselVisitViewComponent_ng_template_2_ng_template_72_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-invoice-list", 33);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("editMode", ctx_r5.editMode && !ctx_r5.cardView)("items", ctx_r5.model.invoices);
  }
}
function VesselVisitViewComponent_ng_template_2_ng_template_75_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-control", 34, 35);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_ng_template_75_Template_app_control_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r9.model.attachments = $event);
    })("addFile", function VesselVisitViewComponent_ng_template_2_ng_template_75_Template_app_control_addFile_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r11 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r11.onAddFile($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("multiple", true)("editMode", ctx_r6.editMode && !ctx_r6.cardView)("ngModel", ctx_r6.model.attachments)("entity", ctx_r6.model);
  }
}
function VesselVisitViewComponent_ng_template_2_ng_template_78_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-note-list", 36);
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("items", ctx_r7.model.notes)("editMode", ctx_r7.editMode && !ctx_r7.cardView);
  }
}
function VesselVisitViewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelement(0, "app-content-header", 3);
    i0.ɵɵelementStart(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "div", 7)(5, "app-control", 8);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_5_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.model.voyageNumber = $event);
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7)(8, "app-control", 9);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.model.vesselId = $event);
    })("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_8_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r15 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r15.onVesselChange($event));
    });
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 7);
    i0.ɵɵelement(11, "app-control", 10);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 7);
    i0.ɵɵelement(14, "app-control", 11);
    i0.ɵɵpipe(15, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 7);
    i0.ɵɵelement(17, "app-control", 11);
    i0.ɵɵpipe(18, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 7);
    i0.ɵɵelement(20, "app-control", 12);
    i0.ɵɵpipe(21, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 6)(23, "div", 7);
    i0.ɵɵelement(24, "app-control", 13);
    i0.ɵɵpipe(25, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(26, "div", 7);
    i0.ɵɵelement(27, "app-control", 14);
    i0.ɵɵpipe(28, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "div", 7)(30, "app-control", 15);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_30_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r16 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r16.model.primaryAgentId = $event);
    });
    i0.ɵɵpipe(31, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(32, "div", 7)(33, "app-control", 16);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_33_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r17 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r17.model.additionalAgents = $event);
    });
    i0.ɵɵpipe(34, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(35, "div", 7)(36, "app-control", 17);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r18 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r18.model.primaryCallPurposeId = $event);
    })("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_36_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.onPrimaryCallPurposesChange($event));
    });
    i0.ɵɵpipe(37, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(38, "div", 7)(39, "app-control", 18);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_39_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r20 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r20.model.callPurposes = $event);
    });
    i0.ɵɵpipe(40, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(41, "div", 6)(42, "div", 19)(43, "app-control", 20);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_43_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.model.portOfCallId = $event);
    });
    i0.ɵɵpipe(44, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(45, "div", 19)(46, "app-control", 21);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_46_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.model.berthId = $event);
    });
    i0.ɵɵpipe(47, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(48, "div", 19)(49, "app-control", 22);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_49_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.model.lastPortOfCallId = $event);
    });
    i0.ɵɵpipe(50, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(51, "div", 19)(52, "app-control", 23);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_52_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r24 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r24.model.nextPortOfCallId = $event);
    });
    i0.ɵɵpipe(53, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(54, "div", 19)(55, "app-control", 24);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_55_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r25 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r25.model.ata = $event);
    });
    i0.ɵɵpipe(56, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(57, "div", 19)(58, "app-control", 25);
    i0.ɵɵlistener("ngModelChange", function VesselVisitViewComponent_ng_template_2_Template_app_control_ngModelChange_58_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r26 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r26.model.atd = $event);
    });
    i0.ɵɵpipe(59, "translate");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementStart(60, "div", 26)(61, "div", 27)(62, "kendo-tabstrip", 28, 29);
    i0.ɵɵlistener("tabSelect", function VesselVisitViewComponent_ng_template_2_Template_kendo_tabstrip_tabSelect_62_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r27 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r27.tabSelected($event));
    });
    i0.ɵɵelementStart(64, "kendo-tabstrip-tab", 30);
    i0.ɵɵpipe(65, "translate");
    i0.ɵɵtemplate(66, VesselVisitViewComponent_ng_template_2_ng_template_66_Template, 1, 2, "ng-template", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(67, "kendo-tabstrip-tab", 30);
    i0.ɵɵpipe(68, "translate");
    i0.ɵɵtemplate(69, VesselVisitViewComponent_ng_template_2_ng_template_69_Template, 1, 2, "ng-template", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(70, "kendo-tabstrip-tab", 30);
    i0.ɵɵpipe(71, "translate");
    i0.ɵɵtemplate(72, VesselVisitViewComponent_ng_template_2_ng_template_72_Template, 1, 2, "ng-template", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(73, "kendo-tabstrip-tab", 30);
    i0.ɵɵpipe(74, "translate");
    i0.ɵɵtemplate(75, VesselVisitViewComponent_ng_template_2_ng_template_75_Template, 2, 4, "ng-template", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(76, "kendo-tabstrip-tab", 30);
    i0.ɵɵpipe(77, "translate");
    i0.ɵɵtemplate(78, VesselVisitViewComponent_ng_template_2_ng_template_78_Template, 1, 2, "ng-template", 31);
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r1.title)("breadcrumb", ctx_r1.breadcrumb)("compacted", ctx_r1.cardView);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(6, 73, "Visit Number"))("ngModel", ctx_r1.model.voyageNumber)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("codelistTake", 1000)("label", i0.ɵɵpipeBind1(9, 75, "Vessel Name"))("ngModel", ctx_r1.model.vesselId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(12, 77, "Vessel IMO Number"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.iMONumber)("isDisabled", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(15, 79, "GRT"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.grossTonnage)("isDisabled", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(18, 81, "NRT"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.netTonnage)("isDisabled", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(21, 83, "LOA"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.length)("isDisabled", true);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(25, 85, "Flag"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.countryId)("isDisabled", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(28, 87, "Vessel Type"))("ngModel", ctx_r1.model.vessel == null ? null : ctx_r1.model.vessel.typeId)("isDisabled", true);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(31, 89, "Primary Agent"))("ngModel", ctx_r1.model.primaryAgentId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(34, 91, "Additional Agents"))("multi", true)("ngModel", ctx_r1.model.additionalAgents)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(37, 93, "Primary Purposes Of Call"))("ngModel", ctx_r1.model.primaryCallPurposeId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(40, 95, "Additional Call Purposes"))("multi", true)("ngModel", ctx_r1.model.callPurposes)("entity", ctx_r1.model);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(44, 97, "Port Of Call"))("ngModel", ctx_r1.model.portOfCallId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(47, 99, "Berth"))("ngModel", ctx_r1.model.berthId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(50, 101, "Last Port Of Call"))("ngModel", ctx_r1.model.lastPortOfCallId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(53, 103, "Next Port Of Call"))("ngModel", ctx_r1.model.nextPortOfCallId)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(56, 105, "Port Of Call ATA"))("time", true)("ngModel", ctx_r1.model.ata)("entity", ctx_r1.model);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("label", i0.ɵɵpipeBind1(59, 107, "Port Of Call ATD"))("time", true)("ngModel", ctx_r1.model.atd)("entity", ctx_r1.model);
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(65, 109, "Events") + " (" + ctx_r1.countActive(ctx_r1.model.events) + ")")("selected", true)("selected", ctx_r1.activeTab === 0);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(68, 111, "Services") + " (" + ctx_r1.countActive(ctx_r1.model.services) + ")")("selected", ctx_r1.activeTab === 1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(71, 113, "Invoices") + " (" + ctx_r1.model.invoices.length + ")")("selected", ctx_r1.activeTab === 2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(74, 115, "Attachments") + " (" + ctx_r1.model.attachments.length + ")")("selected", ctx_r1.activeTab === 3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("title", i0.ɵɵpipeBind1(77, 117, "Remarks") + " (" + ctx_r1.countActive(ctx_r1.model.notes) + ")")("selected", ctx_r1.activeTab === 4);
  }
}
export class VesselVisitViewComponent extends AbstractBreezeViewComponent {
  constructor(breezeViewService, httpClient, datePipe) {
    super(breezeViewService);
    this.breezeViewService = breezeViewService;
    this.httpClient = httpClient;
    this.datePipe = datePipe;
    this.cardView = false;
    this.entityName = 'VesselVisit';
    this.parentRoute = '/vessel-visit';
    this.createPermission = VesselVisitPermissions.Action.create;
    this.editPermission = VesselVisitPermissions.Action.edit;
    this.loadData = {};
    this.dischargeData = {};
    this.breadcrumb = [{
      icon: 'list',
      title: this.translateService.get('Vessel Visit List'),
      route: '/vessel-visit/list'
    }, {
      icon: 'ship',
      title: this.translateService.get('Visit')
    }];
    this.sort = [{
      field: 'containerStatus',
      dir: 'asc'
    }, {
      field: 'projectId',
      dir: 'asc'
    }, {
      field: 'containerSize',
      dir: 'asc'
    }];
    this.fetchCallActivities = (search, value) => super.getCustomcodeList(search, value, 'CallActivities', this.model.primaryCallPurposeId ? this.model.primaryCallPurposeId.toString() : null);
    this.addButtons();
  }
  ngOnInit() {
    if (this.vesselVisit != null) {
      this.model = this.vesselVisit;
      this.breadcrumb = [];
      this.cardView = true;
      this.rememberTabs = false;
    } else {
      super.ngOnInit();
    }
  }
  ngAfterViewInit() {
    // Angular change detection workaround
    setTimeout(() => {
      if (this.cardView && !this.viewMode) super.disableAppControls(this.appControls);
    });
  }
  get title() {
    if (this.isNew) {
      return this.translateService.instant('New Vessel Visit');
    }
    const vesselVisit = this.translateService.instant('Vessel Visit');
    const vessel = this.model.vessel ? ` | ${this.model.vessel.name}` : '';
    const voyageNumber = ` | ${this.model.voyageNumber}`;
    const vesselStatus = ` | ${this.model.statusId}`;
    return `${vesselVisit}${vessel}${voyageNumber}${vesselStatus}`;
  }
  createEntity(data) {
    return super.createEntity({
      voyageNumber: null
    });
  }
  beforeSave() {
    this.model.createdDate = new Date();
    if (this.mode === ViewMode.create) {
      this.model.statusId = VesselVisitStatusCodes.Active;
    }
  }
  addButtons() {
    // eslint-disable-next-line no-unused-expressions
    this.actionBar.push({
      label: this.translateService.instant('Invoice'),
      items: [{
        label: () => this.translateService.instant('Create Invoice'),
        icon: 'plus',
        isVisible: () => !this.createMode,
        onClick: () => this.createInvoice()
      }, {
        label: () => this.translateService.instant('Add Existing Invoice'),
        icon: 'plus',
        isVisible: () => !this.createMode,
        onClick: () => this.addExistingInvoice()
      }]
    }), this.actionBar.push({
      label: this.translateService.instant('Workflow'),
      items: [{
        label: () => this.translateService.instant('Bill'),
        icon: 'file-invoice',
        isVisible: () => !this.createMode,
        isDisabled: () => this.model?.statusId !== VesselVisitStatusCodes.Active,
        onClick: () => this.bill()
      }, {
        label: () => this.translateService.instant('Complete'),
        icon: 'clipboard-check',
        isVisible: () => !this.createMode,
        isDisabled: () => this.model?.statusId !== VesselVisitStatusCodes.Billed,
        onClick: () => this.completed()
      }, {
        label: this.translateService.instant('Send To Archive'),
        icon: 'archive',
        isVisible: () => !this.createMode,
        isDisabled: () => this.model?.archived || this.model?.statusId !== VesselVisitStatusCodes.Completed,
        onClick: () => this.archive()
      }]
    });
  }
  billPortDues() {
    // return new Promise((resolve, reject) => {
    //     this.dialogService.confirm(
    //         this.translateService.instant('Port Dues'),
    //         this.translateService.instant('Do you want to bill Port Dues events?')
    //     ).then((result) => {
    //         if (result) {
    //             const observable = this.apollo.mutate({
    //                 mutation: gql`mutation CreateVesselJob($command: CreateVesselJobAsyncCommandInput!) {
    //                     result: createVesselJob(command: $command)
    //                 }`,
    //                 variables: {
    //                     command: {
    //                         vesselVisitId: this.model.id
    //                     }
    //                 }
    //             });
    //             observable.subscribe(({ data }: any) => {
    //                 this.toastrService.info(this.translateService.instant('Operation was successful.'));
    //                 this.fetch().then(() => {
    //                     resolve(data.result);
    //                 }).catch((error) => {
    //                     reject(error);
    //                 });
    //             }, (error) => {
    //                 this.toastrService.error(this.translateService.instant('Error occurred while processing port dues.'));
    //                 reject(error);
    //             });
    //         } else {
    //             reject();
    //         }
    //     });
    // });
  }
  fetch() {
    return super.fetch().then(() => {
      this.isBusy = true;
      this.httpClient.post('api:///query/VesselVisitSummary', {
        voyageNumber: `${this.model.voyageNumber}`
      }).subscribe(data => {
        this.isBusy = false;
        this.summaryData = data;
        this.setVesselSummaryData();
      });
    });
  }
  setVesselSummaryData() {
    this.loadData.items = _.map(this.summaryData.loadHeader, x => {
      x.teuCount = parseInt(x.containerSize, 10) < 30 ? 1 * x.count : 2 * x.count;
      return x;
    });
    this.dischargeData.items = _.map(this.summaryData.dischargeHeader, x => {
      x.teuCount = parseInt(x.containerSize, 10) < 30 ? 1 * x.count : 2 * x.count;
      return x;
    });
    this.loadData.count = _.sumBy(this.loadData.items, x => x.count);
    this.loadData.teuCount = _.sumBy(this.loadData.items, x => x.teuCount);
    this.dischargeData.count = _.sumBy(this.dischargeData.items, x => x.count);
    this.dischargeData.teuCount = _.sumBy(this.dischargeData.items, x => x.teuCount);
  }
  generatePortDues() {
    // return new Promise((resolve, reject) => {
    //     const dialogRef = this.modalService.open(PortDuesModalComponent, {
    //         size: 'xl',
    //     });
    //     dialogRef.componentInstance.portDues = this.summaryData.portDues;
    //     return dialogRef.result
    //         .then((options) => {
    //             if (_.isEmpty(options)) {
    //                 reject();
    //                 return;
    //             }
    //             const observable = this.apollo.mutate({
    //                 mutation: gql`mutation GenerateVesselEvents($command: GenerateVesselEventsAsyncCommandInput!) {
    //                         result: generateVesselEvents(command: $command)
    //                     }`,
    //                 variables: {
    //                     command: {
    //                         vesselVisitId: this.model.id,
    //                         options,
    //                     }
    //                 }
    //             });
    //             observable.subscribe(({ data }: any) => {
    //                 this.toastrService.info(this.translateService.instant('Operation was successful.'));
    //                 this.isBusy = true;
    //                 this.model = null;
    //                 this.entityManager.clear();
    //                 this.fetch().then(() => {
    //                     resolve(data.result);
    //                 }).catch((error) => {
    //                     reject(error);
    //                 });
    //             }, (error) => {
    //                 this.toastrService.error(this.translateService.instant('Error occurred while processing port dues.'));
    //                 reject(error);
    //             });
    //         })
    //         .catch((e) => {
    //             reject();
    //         });
    // });
  }
  get activeAdditionalWorks() {
    return _.filter(this.model.additionalWork, aw => aw.active).length;
  }
  onAddFile(invoiceAttachment) {
    invoiceAttachment.attachment.internal = true;
  }
  onVesselChange(id) {
    if (!id) {
      return;
    }
    const query = new EntityQuery('Vessel').withParameters({
      $method: 'POST',
      $data: {
        id
      }
    });
    this.breezeViewService.entityManager.executeQuery(query).then(({
      results
    }) => {});
  }
  onPrimaryCallPurposesChange() {
    this.model.callActivityId = null;
  }
  bill() {
    this.breezeViewService.handleCommand('BillVesselVisit', {
      ids: [this.model.id],
      language: 'EN'
    }).then(this.fetch());
  }
  completed() {
    this.breezeViewService.handleCommand('CompleteVesselVisits', {
      ids: [this.model.id],
      language: 'EN'
    }).then(this.fetch());
  }
  archive() {
    this.breezeViewService.handleCommand('ArchiveVesselVisits', {
      ids: [this.model.id]
    }).then(() => this.fetch());
  }
  createInvoice() {
    const servicesList = [];
    const {
      services
    } = this.model;
    services.forEach(el => {
      servicesList.push({
        id: el.id,
        serviceId: el.serviceId,
        description: `${el.description || ''}${`${el.description ? ' ' : ''}${el.serviceDateFrom ? this.datePipe.transform(el.serviceDateFrom, 'dd/MM/yyyy hh:MM') : ''}`}${el.serviceDateTo ? `${el.serviceDateFrom ? ' - ' : ''} ${this.datePipe.transform(el.serviceDateTo, 'dd/MM/yyyy hh:MM')}` : ''}`
      });
    });
    this.router.navigate(['/invoice/create/'], {
      state: {
        data: {
          action: 'vesselVisitCreateInvoice',
          route: this.router.url,
          vesselVisitId: this.model.id,
          voyageNumber: `${this.model.voyageNumber}`,
          ata: this.model.ata,
          vesselId: this.model.vesselId,
          vesselRevisionId: this.model.vesselRevisionId,
          berthId: this.model.berthId,
          services: servicesList,
          customerId: this.model.primaryAgent?.customerId
        }
      }
    });
  }
  addExistingInvoice() {
    const modalRef = this.breezeViewService.openModal(AddExistingInvoiceModalComponent, {
      size: 'xl'
    });
    modalRef.componentInstance.vesselVisitId = this.model.id;
    return modalRef.result.then(() => this.fetch());
  }
}
VesselVisitViewComponent.ɵfac = function VesselVisitViewComponent_Factory(t) {
  return new (t || VesselVisitViewComponent)(i0.ɵɵdirectiveInject(i1.BreezeViewService), i0.ɵɵdirectiveInject(i2.HttpClient), i0.ɵɵdirectiveInject(i3.DatePipe));
};
VesselVisitViewComponent.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
  type: VesselVisitViewComponent,
  selectors: [["app-vessel-visit-view"]],
  viewQuery: function VesselVisitViewComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(_c0, 5);
      i0.ɵɵviewQuery(_c1, 5);
      i0.ɵɵviewQuery(_c2, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.files = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tabStrip = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.callActivitiesControl = _t.first);
    }
  },
  inputs: {
    vesselVisit: "vesselVisit"
  },
  features: [i0.ɵɵProvidersFeature([BreezeViewService, DatePipe]), i0.ɵɵInheritDefinitionFeature],
  decls: 3,
  vars: 2,
  consts: [[3, "items", 4, "ngIf"], [3, "isBusy"], [3, "items"], [3, "title", "breadcrumb", "compacted"], [1, "card", "card-border-top"], [1, "card-body"], [1, "row"], [1, "col"], ["type", "number", "format", "#", "property", "voyageNumber", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Vessel", "property", "vesselId", 3, "codelistTake", "label", "ngModel", "entity", "ngModelChange"], [3, "label", "ngModel", "isDisabled"], ["type", "number", "format", "n3", 3, "label", "ngModel", "isDisabled"], ["type", "number", "format", "n2", 3, "label", "ngModel", "isDisabled"], ["type", "codelist", "codelist", "Country", 3, "label", "ngModel", "isDisabled"], ["type", "codelist", "codelist", "VesselType", 3, "label", "ngModel", "isDisabled"], ["type", "codelist", "codelist", "Agent", "property", "primaryAgentId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Organization", "property", "additionalAgents", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CallPurpose", "property", "primaryCallPurposeId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "CallPurpose", "property", "callPurposes", 3, "label", "multi", "ngModel", "entity", "ngModelChange"], [1, "col-2"], ["type", "codelist", "codelist", "LocalPortFilter", "property", "portOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Berth", "property", "berthId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "lastPortOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["type", "codelist", "codelist", "Port", "property", "nextPortOfCallId", 3, "label", "ngModel", "entity", "ngModelChange"], ["property", "ata", 3, "label", "time", "ngModel", "entity", "ngModelChange"], ["property", "atd", 3, "label", "time", "ngModel", "entity", "ngModelChange"], [1, "row", "mt-3"], [1, "col-12"], [3, "tabSelect"], ["tabStrip", ""], [3, "title", "selected"], ["kendoTabContent", ""], [3, "editMode", "model"], [3, "editMode", "items"], ["type", "file", "property", "attachments", 3, "multiple", "editMode", "ngModel", "entity", "ngModelChange", "addFile"], ["files", ""], [3, "items", "editMode"]],
  template: function VesselVisitViewComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, VesselVisitViewComponent_app_action_bar_0_Template, 1, 1, "app-action-bar", 0);
      i0.ɵɵelementStart(1, "app-loader", 1);
      i0.ɵɵtemplate(2, VesselVisitViewComponent_ng_template_2_Template, 79, 119, "ng-template");
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", !ctx.cardView);
      i0.ɵɵadvance(1);
      i0.ɵɵproperty("isBusy", !ctx.model);
    }
  },
  dependencies: [i3.NgIf, i4.NgControlStatus, i4.NgModel, i5.TabStripComponent, i5.TabStripTabComponent, i5.TabContentDirective, i6.ActionBarComponent, i7.AppControlComponent, i8.LoaderComponent, i9.ContentHeaderComponent, i10.NoteListComponent, i11.InvoiceListComponent, i12.VesselVisitEventListComponent, i13.VesselVisitServiceListComponent, i14.TranslatePipe],
  styles: ["\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZVJvb3QiOiIifQ== */"]
});